import React from 'react';
import { InputGroupAddon, Input } from 'reactstrap';

const navItems = [
    {
        name: 'General'
    },
    {
        name: 'Alerts Settings'
    },
    {
        name: 'Integrations'
    },
    {
        name: 'Plan'
    },
];

export default function MobileNavBar({ handleMode }) {
    return (
        <div style={{ marginTop: '15px' }}>
            <div className="account-mobile">
                <InputGroupAddon addonType="prepend" className="input-group-btn">
                    <Input onChange={(e) => handleMode(e.target.value)} type="select" name="menu">
                        {navItems.map((item, i) => (
                            <option key={i} value={item.name}>
                                {item.name}
                            </option>
                        ))}
                    </Input>
                </InputGroupAddon>
            </div>
        </div>
    );
}
